import { EntBreedingFarm } from "../../../../models/breedingFarm";
import { ResponseDataGet } from "../../../../models/responseDataGet";
import { EntAnaliticalDataHeatAnimalsFilter, EntSummary, EntAnimalPepublicResponse, EntAnimalByRegionItem, EntAnaliticalDataHeatAnimalsFilterRepublic } from "./types"
import { agroApi } from "../../../../redux/api/api";
export const analiticalDataHeatAnimalsApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({


    getAnaliticalDataHeatAnimalSummarysList: builder.query<ResponseDataGet<EntSummary>, EntAnaliticalDataHeatAnimalsFilter>({
  query: (filter) => ({
        url: "/departments/organic/animal-register/analytical-data/summary",
        method: "POST",
        body: JSON.stringify(filter)
      }),
    }),
    getAnaliticalDataHeatAnimalRepublicsList: builder.query<ResponseDataGet<EntAnimalPepublicResponse>, EntAnaliticalDataHeatAnimalsFilter>({
      query: (filter) => ({
            url: "/departments/organic/animal-register/analytical-data/republic",
            method: "POST",
            body: JSON.stringify(filter)
          }),
        }),
        getAnaliticalDataHeatAnimalByRegionsList: builder.query<ResponseDataGet<EntAnimalByRegionItem>, EntAnaliticalDataHeatAnimalsFilter>({
          query: (filter) => ({
                url: "/departments/organic/animal-register/analytical-data/by-region",
                method: "POST",
                body: JSON.stringify(filter)
              }),
            }),
  }),
  overrideExisting: false,
});

export const {
    useGetAnaliticalDataHeatAnimalSummarysListQuery,
    // useLazyGetAnaliticalDataHeatAnimalSummarysListQuery,
    useGetAnaliticalDataHeatAnimalRepublicsListQuery,
    // useLazyGetAnaliticalDataHeatAnimalRepublicsListQuery,
    useGetAnaliticalDataHeatAnimalByRegionsListQuery,
    // useLazyGetAnaliticalDataHeatAnimalByRegionsListQuery
} = analiticalDataHeatAnimalsApi;
